import { render, staticRenderFns } from "./OrderComments.vue?vue&type=template&id=6983ac3c&scoped=true"
import script from "./OrderComments.vue?vue&type=script&lang=js"
export * from "./OrderComments.vue?vue&type=script&lang=js"
import style0 from "./OrderComments.vue?vue&type=style&index=0&id=6983ac3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983ac3c",
  null
  
)

export default component.exports